import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const ChelseaHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);

    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("Chelsea"));
        
        const fav = {
            teamName: "Chelsea",
            teamLogo: PLsoccerLogos["Chelsea"],
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
            const fetchFavorites = async () => {
                try {
                        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Chelsea`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                        credentials: "include",
                    });
        
                    if (!res.ok) {
                        console.log("No favorites found or error fetching");
                        setFavoritesLoaded(true);
                        return;
                    }
                    const data = await res.json();
        
                    // highlight team star
                    setIsTeamFavorite(data.team?.isFavorite || false);
        
                    // highlight player stars
                    const playerKeys = data.players
                        .filter(p => p.isFavorite && p.name.startsWith("Chelsea"))
                        .map(p => p.name);  
                    setStarredPlayers(playerKeys);
                    setFavoritesLoaded(true);
    
                } catch (err) {
                    console.error("Error fetching favorites", err);
                }
            };
        
            fetchFavorites();
        }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["Chelsea"]}
                        alt="Chelsea"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>Chelsea</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal); 
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="Chelsea" /></p>
                        <p><span className="soccer-label">Stadium:</span> Stamford Bridge</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Liam Rosenior</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Kalifa Cisse, Calum McFarlane, Justin Walker, Willy Caballero</p>
                    </div>
                </section>
            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="Chelsea"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="Chelsea" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="Chelsea" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• Only London based club to win the Champions League</p>
                        <br />
                        <p>• Holds the record for the fewest goals conceded in a single Premier League campaign, only 15 goals in the 2004/2004 season</p>
                        <br />
                        <p>• The club was bought by Ken Bates for $1</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ChelseaHome;